function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
// import { useSelector } from 'react-redux';
// import { winnreAuth } from '../../utils/axios';

var useData = function useData(_ref) {
  var winnreAuth = _ref.winnreAuth,
    redux = _ref.redux,
    router = _ref.router,
    appType = _ref.appType;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    pointActivitiesList = _useState2[0],
    setPointActivitiesList = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(8),
    _useState6 = _slicedToArray(_useState5, 2),
    loadMore = _useState6[0],
    setLoadMore = _useState6[1];
  var _useState7 = useState(1),
    _useState8 = _slicedToArray(_useState7, 2),
    totalPages = _useState8[0],
    setTotalPages = _useState8[1];
  var isAuthenticated = redux.isAuthenticated;
  var getPointActivitiesList = function getPointActivitiesList() {
    setLoading(true);
    winnreAuth({
      method: 'GET',
      url: "/winnre/user/reward-audit?rewardType=RELOY_REWARDS&isAscending=false&pageSize=".concat(loadMore, "&isAscending=false")
    }).then(function (res) {
      console.log('all point activity', res);
      if ((res === null || res === void 0 ? void 0 : res.status) === 'INVALID_TOKEN' || (res === null || res === void 0 ? void 0 : res.status) === 'FAILED') {
        setTotalPages(0);
        toast.error('Something Went Wrong');
        return;
      }
      if ((res === null || res === void 0 ? void 0 : res.status) === 'UNAUTHORIZED') {
        setTotalPages(0);
        toast.error('Unauthorized');
        return;
      }
      setLoading(false);
      var filteredContent = Array.isArray(res === null || res === void 0 ? void 0 : res.content) ? res.content.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.points) !== 0 && (item === null || item === void 0 ? void 0 : item.point) !== 0;
      }) : [];
      setPointActivitiesList(filteredContent);
      setTotalPages(res.totalPages || 1);
    })["catch"](function (err) {
      toast.error('Something went wrong. Please try again');
    });
  };
  useEffect(function () {
    if (isAuthenticated) {
      getPointActivitiesList();
    }
  }, [isAuthenticated]);
  return {
    loading: loading,
    pointActivitiesList: pointActivitiesList,
    setLoadMore: setLoadMore,
    totalPages: totalPages
  };
};
export default useData;